module.exports = function ($timeout, performance) {
    return {
        restrict: 'A',
        link(scope, element, attrs) {
            if (!attrs.wowPerformanceEndMeasure) {
                return;
            }

            $timeout(function () {
                performance.endMeasure(attrs.wowPerformanceEndMeasure);
            }, 0, false);
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/performance/performance-end-measure-directive.js
 **/